//export const companiesBsoNeedsCheque = [2, 3, 4, 7, 8];
export const companiesBsoNeedsCheque = [3, 8, 10];
export const companiesBsoMandatoryCheque = [];

export const companiesEbsoNeedNumber = [];
//export const companiesEbsoNeedsCheque = [2, 3, 7, 8];
//export const companiesEbsoNeedsCheque = [3, 8, 10];
export const companiesEbsoNeedsCheque = [];

export const companiesLinkedProlong = [2, 5, 7, 9];